module.exports = __webpack_public_path__ + "img/trash-white.6a97a764.svg";